export type SidePanelTab = 'about' | 'notes';

interface LandmarkPanelTabsProps {
  activeTab: SidePanelTab;
  onChange: (tab: SidePanelTab) => void;
}

export function LandmarkPanelTabs({ activeTab, onChange }: LandmarkPanelTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Landmark sections"
      data-testid="landmark-panel-tabs"
      style={{
        display: 'flex',
        gap: 'var(--space-2)',
        borderBottom: '1px solid var(--border)',
        marginBottom: 'var(--space-4)',
        marginTop: 'var(--space-1)',
      }}
    >
      <TabButton tab="about" label="About" active={activeTab === 'about'} onChange={onChange} />
      <TabButton tab="notes" label="Notes" active={activeTab === 'notes'} onChange={onChange} />
    </div>
  );
}

function TabButton({
  tab,
  label,
  active,
  onChange,
}: {
  tab: SidePanelTab;
  label: string;
  active: boolean;
  onChange: (tab: SidePanelTab) => void;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      aria-controls={`tabpanel-${tab}`}
      data-testid={`tab-${tab}`}
      onClick={() => onChange(tab)}
      style={{
        padding: '8px var(--space-3)',
        marginBottom: -1,
        borderBottom: active ? '2px solid var(--primary)' : '2px solid transparent',
        color: active ? 'var(--text-headline)' : 'var(--text-muted)',
        fontWeight: active ? 600 : 500,
        fontSize: '0.9rem',
        transition: 'color 120ms ease',
      }}
    >
      {label}
    </button>
  );
}
